import Vue from 'vue'
import VueI18n from 'vue-i18n'
import EN from 'element-ui/lib/locale/lang/en'
import Zh_CN from 'element-ui/lib/locale/lang/zh-CN'

import ENLocale from './en-US'
import ZH_CNLocale from './zh-CN'

Vue.use(VueI18n)
const messages = {
  'zh-CN': {
    ...ZH_CNLocale,
    ...Zh_CN
  },
  'en-US': {
    ...ENLocale,
    ...EN
  },
}

const i18n = new VueI18n({
  locale: localStorage.getItem('Accept-Language') || 'zh-CN', // 设置语种
  messages, // 设置全局当地语言包,
  fallbackLocale: 'zh-CN', //如果没有找到要显示的语言，则默认显示 ‘zh-CN’
  silentTranslationWarn: true // 关闭警告信息
})

export default i18n;
